module.exports = __webpack_public_path__ + "img/consultoria2_4-3_2048.e7f959d1.webp";